import { FILTER_OPTIONS, SORT_OPTIONS } from '@/modules/pmt/constants';
import { useShipmentFiltersContext, useShipmentsOverviewContext } from '@/modules/pmt/context';
import { AnimatePresence, type Variants } from 'framer-motion';
import { NoParcelsFound } from '../NoParcels';
import { AnimateListWrapper } from './ShipmentList.styles';
import { DeliveredShipments } from './components/DeliveredShipments';
import { Shipments } from './components/Shipments';

const animationVariantsBoxContainer: Variants = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.3,
    },
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.3,
    },
  },
};

export const ShipmentList = () => {
  const { filterConfig } = useShipmentFiltersContext();
  const { noShipmentsFound } = useShipmentsOverviewContext();

  if (noShipmentsFound) return <NoParcelsFound />;

  const showDeliveredShipments =
    filterConfig.currentFilter === FILTER_OPTIONS.ALL && filterConfig.currentSort === SORT_OPTIONS.DELIVERY_DATE;

  return (
    <AnimateListWrapper exit='hidden' animate='show' initial='hidden' variants={animationVariantsBoxContainer}>
      <AnimatePresence>{showDeliveredShipments && <DeliveredShipments />}</AnimatePresence>
      <AnimatePresence>
        <Shipments />
      </AnimatePresence>
    </AnimateListWrapper>
  );
};
